"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoVariant = exports.JodlApplicantReturnStatus = exports.JodlReturnFlowVariant = exports.JodlOtpDeliveryMethod = exports.JodlReturnJwtType = exports.NextHomeApplicationAction = void 0;
var NextHomeApplicationAction;
(function (NextHomeApplicationAction) {
    // Application should be redirected to Stated Usage page
    NextHomeApplicationAction["STATED_USAGE"] = "statedUsage";
    // Application should be redirected to UCC Upgrade Stated Usage page
    NextHomeApplicationAction["UCC_UPGRADE_STATED_USAGE"] = "uccUpgradeStatedUsage";
    // Application should be redirected to Aven Cash Upgrade Stated Usage page
    NextHomeApplicationAction["AVEN_CASH_UPGRADE_STATED_USAGE"] = "avenCashUpgradeStatedUsage";
    // Applicant should be redirected to Personal Info page
    NextHomeApplicationAction["PERSONAL_INFO"] = "personalInfo";
    // Applicant should be redirected to Add Authorized User page
    // This is only related to UCC for now.
    NextHomeApplicationAction["ADD_AUTHORIZED_USER"] = "addAuthorizedUser";
    // Applicant should be redirected to Tax Return Address page
    NextHomeApplicationAction["TAX_RETURN_ADDRESS"] = "taxReturnAddress";
    // Applicant should be redirected to Stated Income page
    NextHomeApplicationAction["STATED_INCOME"] = "statedIncome";
    // Applicant should be redirected to Identity Verification page
    NextHomeApplicationAction["VERIFY_IDENTITY"] = "verifyIdentity";
    // Applicant should be direct to name mismatch remedy flow
    NextHomeApplicationAction["NAME_MISMATCH_REMEDY"] = "nameMismatchRemedy";
    // Applicant should be directed to the Thanks page
    NextHomeApplicationAction["THANKS"] = "thanks";
    // Applicant should be directed to the Thanks page with the identity-verification failure reason
    NextHomeApplicationAction["THANKS_IDENTITY"] = "thanksIdentity";
    // Applicant should be directed to offer add joint co applicant page
    NextHomeApplicationAction["OFFER_ADD_COAPPLICANT"] = "offerAddCoApplicant";
    NextHomeApplicationAction["MORTGAGE_STATEMENT"] = "mortgageStatement";
    // Used in UCC for renters
    NextHomeApplicationAction["ASSET_VERIFICATION"] = "assetVerification";
    // Used in UCC for document signing
    NextHomeApplicationAction["SIGN_DOCUMENTS"] = "signDocuments";
    // Used in UCC for identity fraud checks
    NextHomeApplicationAction["IDENTITY_CHECKS"] = "identityChecks";
    // Applicant should view the pre-qual page
    NextHomeApplicationAction["PRE_QUALIFICATION"] = "preQualification";
    // Applicant still needs to acknowledge state modules post-PQ
    // TODO Remove POST_PRE_QUAL_STATE_MODULES in favor of POST_PRE_QUAL_STATE_MODULES_AND_MARITAL_STATUS
    NextHomeApplicationAction["POST_PRE_QUAL_STATE_MODULES"] = "postPreQualStateModules";
    // Applicant still needs to acknowledge state modules post-PQ or add their marital status
    NextHomeApplicationAction["POST_PRE_QUAL_STATE_MODULES_AND_MARITAL_STATUS"] = "postPreQualStateModulesAndMaritalStatus";
    // Applicant should view the hmda questionnaire
    NextHomeApplicationAction["HMDA"] = "hmda";
    // Income V2
    NextHomeApplicationAction["INCOME_VERIFICATION_V2"] = "incomeVerificationV2";
    // Applicant should view the appropriate income verification page
    NextHomeApplicationAction["EMPLOYMENT_INCOME_VERIFICATION"] = "employmentIncomeVerification";
    NextHomeApplicationAction["INCOME_VERIFICATION"] = "incomeVerification";
    NextHomeApplicationAction["CREDIT_LIMIT_INCREASE_RESULT"] = "creditLimitIncreaseResult";
    NextHomeApplicationAction["INCOME_VERIFICATION_TAX_RETURN"] = "incomeVerificationTaxReturn";
    NextHomeApplicationAction["INCOME_VERIFICATION_BANK_STATEMENT"] = "incomeVerificationBankStatement";
    NextHomeApplicationAction["INCOME_VERIFICATION_PAY_STUB"] = "incomeVerificationPayStub";
    NextHomeApplicationAction["INCOME_DOCUMENT_UPLOAD_PORTAL"] = "incomeDocumentUploadPortal";
    // LLC/business entity applicants upload business docs (articles of org, EIN letter, operating agreement)
    NextHomeApplicationAction["BUSINESS_VERIFICATION"] = "businessVerification";
    // LLC/business entity applicants whose docs are uploaded and awaiting ops review
    NextHomeApplicationAction["BUSINESS_VERIFICATION_SUBMITTED"] = "businessVerificationSubmitted";
    NextHomeApplicationAction["CURRENT_RENT_VERIFICATION_SELECTION"] = "currentRentVerificationSelection";
    // Applicant should view the collateral provenance page (crypto only)
    NextHomeApplicationAction["COLLATERAL_PROVENANCE"] = "collateralProvenance";
    // Applicant should view the offer preview page
    NextHomeApplicationAction["OFFER_PREVIEW"] = "offerPreview";
    // Applicant should view the early bank connection page (pre-notary upfront cash-out bank connection)
    NextHomeApplicationAction["EARLY_BANK_CONNECTION"] = "earlyBankConnection";
    // In Churn Retention flow, applicant confirms their cash-out destination bank account before notary
    NextHomeApplicationAction["CONFIRM_CASH_OUT_BANK_ACCOUNT"] = "confirmCashOutBankAccount";
    // Applicant should view the escrow opt-in page
    NextHomeApplicationAction["ESCROW_OPT_IN"] = "escrowOptIn";
    // Applicant should view the appropriate flood insurance verification page
    NextHomeApplicationAction["FLOOD_INSURANCE_VERIFICATION"] = "floodInsuranceVerification";
    // Applicant is waiting on CoreLogic Life-of-Loan flood-zone research to resolve. They land on a
    // thanks page explaining that we will reach out when they can continue.
    NextHomeApplicationAction["FLOOD_ZONE_DETERMINATION_PENDING"] = "floodZoneDeterminationPending";
    // Applicant should view the homeowners insurance upload page (first-lien, escrow opted-in, not in flood zone)
    NextHomeApplicationAction["HOMEOWNERS_INSURANCE_VERIFICATION"] = "homeownersInsuranceVerification";
    // Applicant should be redirected to either coOwner page OR trust page
    // i.e. whatever they would normally see after accepting an offer
    NextHomeApplicationAction["POST_ACCEPT"] = "postAccept";
    // Applicant should be directed to the notary product
    NextHomeApplicationAction["NOTARIZATION"] = "notarization";
    // Applicant must resolve active notary-scheduling-blocking conditions before they can schedule notarization
    NextHomeApplicationAction["NOTARY_BLOCKING_CONDITIONS"] = "notaryBlockingConditions";
    // Applicant's EBC account is verified with no autopay election on file, so prompt before the notary handoff
    NextHomeApplicationAction["EARLY_AUTO_PAY_OPT_IN"] = "earlyAutoPayOptIn";
    // Applicant is already a customer so they should view the Welcome page
    NextHomeApplicationAction["WELCOME"] = "welcome";
    NextHomeApplicationAction["DENIED"] = "denied";
    NextHomeApplicationAction["PENDING"] = "pending";
    NextHomeApplicationAction["REVIEW"] = "review";
    NextHomeApplicationAction["COOWNER_DISPUTE"] = "coownerDispute";
    NextHomeApplicationAction["REVIEW_UPLOADED_DOC"] = "reviewUploadedDoc";
    // Applicant will see page for accepting or dispute their denial reason
    NextHomeApplicationAction["DISPUTE_DENIAL"] = "disputeDenial";
    // Roadblock page for when a user is in a not supported state
    NextHomeApplicationAction["UNSUPPORTED_STATE"] = "unsupportedState";
    // Similar to UNSUPPORTED_STATE but other reasons being on waitlist
    NextHomeApplicationAction["WAITLIST"] = "waitlist";
    // Applicant has closed their application (withdrawn/declined)
    NextHomeApplicationAction["CLOSED"] = "closed";
    // In Churn Retention flow, applicant will see the page for Balance Sweep
    NextHomeApplicationAction["BALANCE_SWEEP"] = "balance_sweep";
    // In Churn retention flow, if there is no CLI, user would skip notary and go to docusign page
    NextHomeApplicationAction["CHURN_RETENTION_DOCUSIGN"] = "churn_retention_docusign";
    // In Churn retention flow, it could be that user has no CLI offer and has been in approved status,
    // we would move user to a new welcome page in this scenario
    NextHomeApplicationAction["CHURN_RETENTION_SKIP_NOTARY_WELCOME"] = "churn_retention_skip_notary_welcome";
    // Applicant is waiting for pre-approval credit card to be sent, blocking and does not allow applicant to move forward
    // until SendCardPriorToApproval microflow status is marked as "received"
    NextHomeApplicationAction["EARLY_CREDIT_CARD_CONFIRMATION_PAGE"] = "early_credit_card_confirmation_page";
    // Applicant has received the pre-approval credit card, allows applicant to move forward in flow to secondary signers + notary schedule
    NextHomeApplicationAction["EARLY_CREDIT_CARD_RECEIVED_PAGE"] = "early_credit_card_received_page";
    // lien attestation page for first lien position
    NextHomeApplicationAction["FIRST_LIEN_ATTESTATION_PAGE"] = "first_lien_attestation_page";
    // Appraisal flow pages for first lien refi with line size > 400k
    NextHomeApplicationAction["APPRAISAL_NEEDED_PAGE"] = "appraisalNeededPage";
    NextHomeApplicationAction["WAITING_FOR_APPRAISAL_PAGE"] = "waitingForAppraisalPage";
    NextHomeApplicationAction["DUPLICATED"] = "duplicated";
    NextHomeApplicationAction["EXPIRED"] = "expired";
    // Applicant's identity could not be verified
    NextHomeApplicationAction["UNABLE_TO_VERIFY_IDENTITY"] = "unableToVerifyIdentity";
    // Partner handoff flow — applicant originated from partner/TLS, needs to review info + identity verification
    NextHomeApplicationAction["PARTNER_HANDOFF_REVIEW"] = "partnerHandoffReview";
    // Merchant-API-originated flow — LA was created via /offers/getPreQualOffers by a partner with
    // isUsingMerchantOrigination; applicant lands on the portal loan-application-review page for identity
    // verification and review.
    NextHomeApplicationAction["PORTAL_LOAN_APPLICATION_REVIEW"] = "portalLoanApplicationReview";
    // Merchant-portal "send application to applicant" flow — applicant arrived via SMS link,
    // loan application created with default portal UW policy, applicant must pick a financing option next.
    NextHomeApplicationAction["PORTAL_SELECT_FINANCING_OPTION"] = "portalSelectFinancingOption";
    // Merchant-portal "send application to applicant" flow — applicant has picked a financing option
    // but hasn't yet provided PII. Route them to the personal info page to collect PII before identity verification.
    NextHomeApplicationAction["PORTAL_LOAN_APPLICATION_PERSONAL_INFO"] = "portalLoanApplicationPersonalInfo";
    // Merchant-portal flow — IDology SSN completion failed for the primary applicant (last-4 SSN
    // did not resolve), leaving them without a personGuid. Route to the full-SSN recovery page
    // before continuing, otherwise prequal underwriting later crashes on a null personGuid.
    NextHomeApplicationAction["PORTAL_SSN_VERIFICATION"] = "portalSsnVerification";
    // Merchant-portal flow — same as PORTAL_SSN_VERIFICATION, but for the co-applicant.
    NextHomeApplicationAction["PORTAL_CO_APPLICANT_SSN_VERIFICATION"] = "portalCoApplicantSsnVerification";
    // Merchant-portal flow — applicant needs to attempt Persona identity verification before account
    // creation. Routes to a portal-specific path that re-uses the standard UCC IdentityChecks page;
    // post-Persona the page routes back to PORTAL_PRE_QUAL_OFFER instead of the UCC welcome flow.
    NextHomeApplicationAction["PORTAL_IDENTITY_CHECKS"] = "portalIdentityChecks";
    // Merchant-portal home flow — applicant has verified identity but has not yet selected pre-qual
    // terms. Route them to the contractor payment plan picker page.
    NextHomeApplicationAction["PORTAL_SELECT_CONTRACTOR_PAYMENT_PLAN"] = "portalSelectContractorPaymentPlan";
    // Merchant-portal rewards (UCC) flow — applicant has verified identity but the rewards account
    // has not yet been created. Route them to the pre-qual offer page.
    NextHomeApplicationAction["PORTAL_PRE_QUAL_OFFER"] = "portalPreQualOffer";
    // Deposit application flow
    NextHomeApplicationAction["DEPOSIT_WELCOME_ADD_FUNDS"] = "depositWelcomeAddFunds";
    NextHomeApplicationAction["DEPOSIT_WELCOME"] = "depositWelcome";
    // Mortgage application flow
    // First page of the mortgage extended application microflow, shown after offer acceptance for applicants in the mortgageExtendedApplication
    // experiment. Corresponds to MortgageExtendedApplicationStatus.refiConfirm.
    NextHomeApplicationAction["REFI_CONFIRM"] = "refiConfirm";
    // Second page of the mortgage extended application microflow, where the applicant self-attests the subject property type.
    // Corresponds to MortgageExtendedApplicationStatus.propertyType.
    NextHomeApplicationAction["PROPERTY_TYPE"] = "propertyType";
    // Third page of the mortgage extended application microflow, where the applicant confirms the estimated value of the
    // subject property. Corresponds to MortgageExtendedApplicationStatus.propertyValue.
    NextHomeApplicationAction["PROPERTY_VALUE"] = "propertyValue";
    // Fourth page of the mortgage extended application microflow, where the applicant confirms who should be listed on the
    // subject property's title. Corresponds to MortgageExtendedApplicationStatus.homeOwner.
    NextHomeApplicationAction["HOME_OWNER"] = "homeOwner";
    NextHomeApplicationAction["ADDRESS_HISTORY"] = "addressHistory";
    NextHomeApplicationAction["DEPENDENTS"] = "dependents";
    NextHomeApplicationAction["SUBJECT_PROPERTY"] = "subjectProperty";
    NextHomeApplicationAction["OTHER_PROPERTIES"] = "otherProperties";
    NextHomeApplicationAction["OTHER_ASSETS"] = "otherAssets";
    NextHomeApplicationAction["DECLARATION_QUESTIONS"] = "declarationQuestions";
    NextHomeApplicationAction["EMPLOYMENT_HISTORY"] = "employmentHistory";
    NextHomeApplicationAction["OTHER_INCOME"] = "otherIncome";
    NextHomeApplicationAction["URLA_CONFIRMATION"] = "urlaConfirmation";
    NextHomeApplicationAction["MORTGAGE_PORTAL"] = "mortgagePortal";
    NextHomeApplicationAction["DOCUMENT_PORTAL"] = "documentPortal";
    NextHomeApplicationAction["FIRST_LIEN_PURCHASE_PRE_APPROVAL"] = "firstLienPurchasePreApproval";
    NextHomeApplicationAction["FIRST_LIEN_PURCHASE_PURCHASE_CONTRACT_UPLOAD"] = "firstLienPurchasePurchaseContractUpload";
    NextHomeApplicationAction["FIRST_LIEN_PURCHASE_SETTLEMENT_CONFIRMATION"] = "firstLienPurchaseSettlementConfirmation";
    NextHomeApplicationAction["FIRST_LIEN_PURCHASE_VERIFY_IDENTITY"] = "firstLienPurchaseVerifyIdentity";
    NextHomeApplicationAction["FIRST_LIEN_PURCHASE_PURCHASE_LOCATION"] = "firstLienPurchasePurchaseLocation";
    NextHomeApplicationAction["FIRST_LIEN_PURCHASE_STATED_INCOME"] = "firstLienPurchaseStatedIncome";
    NextHomeApplicationAction["FIRST_LIEN_PURCHASE_STATED_ASSETS"] = "firstLienPurchaseStatedAssets";
    NextHomeApplicationAction["FIRST_LIEN_PURCHASE_ESTIMATED_CLOSING_COSTS"] = "firstLienPurchaseEstimatedClosingCosts";
    NextHomeApplicationAction["FIRST_LIEN_PURCHASE_PREPARING_FOR_CLOSING"] = "firstLienPurchasePreparingForClosing";
    NextHomeApplicationAction["FIRST_LIEN_PURCHASE_PREWIRE_OFFER"] = "firstLienPurchasePrewireOffer";
    NextHomeApplicationAction["FIRST_LIEN_PURCHASE_CLOSING_PAGE"] = "firstLienPurchaseClosingPage";
})(NextHomeApplicationAction || (exports.NextHomeApplicationAction = NextHomeApplicationAction = {}));
var JodlReturnJwtType;
(function (JodlReturnJwtType) {
    JodlReturnJwtType["applicant"] = "applicant";
    JodlReturnJwtType["notary"] = "notary";
})(JodlReturnJwtType || (exports.JodlReturnJwtType = JodlReturnJwtType = {}));
var JodlOtpDeliveryMethod;
(function (JodlOtpDeliveryMethod) {
    JodlOtpDeliveryMethod["sms"] = "sms";
    JodlOtpDeliveryMethod["call"] = "call";
})(JodlOtpDeliveryMethod || (exports.JodlOtpDeliveryMethod = JodlOtpDeliveryMethod = {}));
var JodlReturnFlowVariant;
(function (JodlReturnFlowVariant) {
    JodlReturnFlowVariant["origination"] = "origination";
    JodlReturnFlowVariant["documentUploadPortal"] = "documentUploadPortal";
    JodlReturnFlowVariant["hmda"] = "hmda";
    JodlReturnFlowVariant["ogProductDetails"] = "ogProductDetails";
})(JodlReturnFlowVariant || (exports.JodlReturnFlowVariant = JodlReturnFlowVariant = {}));
var JodlApplicantReturnStatus;
(function (JodlApplicantReturnStatus) {
    JodlApplicantReturnStatus["challenge"] = "challenge";
    JodlApplicantReturnStatus["issued"] = "issued";
    JodlApplicantReturnStatus["verified"] = "verified";
    JodlApplicantReturnStatus["error"] = "error";
    JodlApplicantReturnStatus["resetSession"] = "resetSession";
})(JodlApplicantReturnStatus || (exports.JodlApplicantReturnStatus = JodlApplicantReturnStatus = {}));
var LogoVariant;
(function (LogoVariant) {
    LogoVariant["regular"] = "regular";
    LogoVariant["atp"] = "atp";
})(LogoVariant || (exports.LogoVariant = LogoVariant = {}));
